App.OrderOrganizationSelectComponent = Em.Component.extend
  classNames: [ 'order-organization-select' ]

  organizations: []

  actions:
    organizationSelected: (organization) ->
      @sendAction 'onOrganizationSelect', organization
      false

